import { styled } from '@shared/ui/styled';

export const Pane = styled('aside', {
  shouldForwardProp: p => !['$width', '$collapsed'].includes(p),
})(({ $width, $collapsed }) => ({
  position: 'relative',
  width: $collapsed ? 48 : $width,
  flexShrink: 0,
  background: 'var(--qhs-surface)',
  borderLeft: '1px solid var(--qhs-border)',
  boxShadow: '-8px 0 24px rgba(10, 20, 64, 0.08)',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  transition: 'width 360ms cubic-bezier(0.4, 0, 0.2, 1)',
  animation: 'qhsInfoPaneSlideIn 360ms cubic-bezier(0.4, 0, 0.2, 1)',
  cursor: $collapsed ? 'pointer' : 'default',
  '&:hover': $collapsed ? { background: 'var(--qhs-surface-hover)' } : undefined,
  '@keyframes qhsInfoPaneSlideIn': {
    '0%': { transform: 'translateX(8px)', opacity: 0.6 },
    '100%': { transform: 'translateX(0)', opacity: 1 },
  },
}));

export const Header = styled('header')({
  position: 'sticky',
  top: 0,
  zIndex: 2,
  background: 'var(--qhs-surface)',
  padding: '14px 18px 14px 20px',
  borderBottom: '1px solid var(--qhs-border)',
  display: 'flex',
  alignItems: 'center',
  gap: 10,
});

export const Body = styled('div')({
  flex: 1,
  overflowY: 'auto',
  scrollbarWidth: 'thin',
});

export const Footer = styled('footer')({
  position: 'sticky',
  bottom: 0,
  // `--qhs-bg` is the same token the tables' bottom toolbar uses; the
  // previous `--qhs-surface-2` never existed, so its light fallback was
  // what painted this footer white on the dark pane.
  background: 'var(--qhs-bg)',
  borderTop: '1px solid var(--qhs-border)',
  padding: '12px 16px',
  display: 'flex',
  gap: 8,
  alignItems: 'center',
});

export const CollapsedRail = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  flex: 1,
  padding: '18px 0',
});
